import { TextField } from '@components/text-field'
import { DateInputConfig } from '@st/ui-config'
import { IconTip } from '@st/theme'
import { ConfigInputProps } from '@util/input-component'

type DateInputProps = ConfigInputProps<DateInputConfig, string> & {
  className?: string
  placeholder?: string
  onBlur?: () => void
}
export function DateInput({
  className,
  value,
  label,
  onChange,
  onBlur,
  placeholder = 'mm/dd/yyyy',
  tip
}: DateInputProps) {
  return (
    <TextField
      type="text"
      className={className}
      value={value}
      label={label}
      tip={
        tip == null ? undefined : (
          <IconTip title={tip.title} body={tip.body} className="text-blue-500" />
        )
      }
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
    />
  )
}
